// extracted by mini-css-extract-plugin
export var actions = "_qv-5";
export var assistantBubble = "_qv-3";
export var assistantRow = "_qv-6";
export var bubble = "_qv-0";
export var humanAvatar = "_qv-4";
export var inlineToolCard = "_qv-1";
export var userBubble = "_qv-2";